import type { VehicleLayout } from '@chukua/vehicle-model';

/**
 * A truck and the trailer it pulls are drawn as one rig (gitaumoses4/chukua#390), and both can have an `A2LO`. Inside the drawing
 * the trailer's position codes carry this prefix, so a tyre is picked, highlighted and tagged as the trailer's; nothing outside
 * the drawing ever sees it.
 */
const TOWED_PREFIX = 'TOWED:';

export type DiagramPart = 'main' | 'towed';

export function qualifyCode(code: string, part: DiagramPart): string {
  return part === 'towed' ? `${TOWED_PREFIX}${code}` : code;
}

/** Which vehicle a code drawn on the rig belongs to, and its own code. */
export function partOfCode(code: string): { part: DiagramPart; code: string } {
  return code.startsWith(TOWED_PREFIX) ? { part: 'towed', code: code.slice(TOWED_PREFIX.length) } : { part: 'main', code };
}

/** The code as a tag shows it: the trailer's own, without the prefix. */
export function displayCode(code: string): string {
  return partOfCode(code).code;
}

/** The trailer's layout with its codes qualified and its positions named as the trailer's. */
export function asTowedLayout(layout: VehicleLayout): VehicleLayout {
  return {
    ...layout,
    axles: layout.axles.map((axle) => ({
      ...axle,
      tyres: axle.tyres.map((tyre) => ({ ...tyre, code: qualifyCode(tyre.code, 'towed'), name: `Trailer · ${tyre.name}` })),
    })),
  };
}
